import React, { useState, useEffect, forwardRef } from "react";
import { Row, Col, Descriptions, Divider, Tag, Button, Image, Space, QRCode } from 'antd';
import Footer from "./pieces/Footer";
import { Parser } from "html-to-react";
import DocumentHeader from "./DocumentHeader";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var ExitPaper = function ExitPaper(_ref) {
  var _ref$hospitalization = _ref.hospitalization,
      hospitalization = _ref$hospitalization === void 0 ? null : _ref$hospitalization;
  useEffect(function () {
    if (hospitalization == null || hospitalization.customer == null) return;
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      style: {
        padding: '28px'
      },
      children: /*#__PURE__*/_jsx(Row, {
        gutter: 16,
        children: /*#__PURE__*/_jsxs(Col, {
          span: 24,
          children: [/*#__PURE__*/_jsx(DocumentHeader, {
            title: "Fiche de sortie d'hospitalisation"
          }), /*#__PURE__*/_jsx(Row, {
            gutter: 16,
            children: /*#__PURE__*/_jsx(Col, {
              children: hospitalization && /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("div", {
                  style: {
                    background: "#F3F2EE",
                    padding: "22px",
                    borderRadius: "7px"
                  },
                  children: /*#__PURE__*/_jsxs(Descriptions, {
                    column: 2,
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      labelStyle: {
                        fontWeight: 'Bold'
                      },
                      span: 2,
                      contentStyle: {
                        fontWeight: 'Bold'
                      },
                      label: "CODE PATIENT",
                      children: hospitalization.customer.idnumber
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Pr\xE9nom"
                      }),
                      children: hospitalization.customer.firstname
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Nom"
                      }),
                      children: hospitalization.customer.lastname
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Tel."
                      }),
                      children: hospitalization.customer.mobile.toString().slice(3)
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Genre"
                      }),
                      children: hospitalization.customer.gender == 'F' ? "Femme" : "Homme"
                    }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Age"
                      }),
                      children: [hospitalization.customer.birthdate, " ans"]
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Profession"
                      }),
                      children: hospitalization.customer.job
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Motif"
                      }),
                      children: hospitalization.reason
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "M\xE9decin traitant"
                      }),
                      children: hospitalization.pratician_name
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Type"
                      }),
                      children: /*#__PURE__*/_jsxs("div", {
                        children: [hospitalization.entry_mode == 0 && /*#__PURE__*/_jsx(Tag, {
                          color: "#f50",
                          children: "Urgence"
                        }), hospitalization.entry_mode == 1 && /*#__PURE__*/_jsx(Tag, {
                          color: "#409964",
                          children: "Programm\xE9"
                        }), hospitalization.entry_mode == 2 && /*#__PURE__*/_jsx(Tag, {
                          color: "#996940",
                          children: "Transfert"
                        })]
                      })
                    })]
                  })
                }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Synth\xE8se m\xE9dicale du s\xE9jour"
                  })
                }), /*#__PURE__*/_jsx("div", {
                  children: Parser().parse(hospitalization.synthesis)
                }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Recommandations"
                  })
                }), /*#__PURE__*/_jsx("div", {
                  children: Parser().parse(hospitalization.recommandation)
                }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Destination du patient \xE0 la sortie"
                  })
                }), /*#__PURE__*/_jsx("div", {
                  children: hospitalization.destination
                })]
              })
            })
          })]
        })
      })
    })
  });
};

export default ExitPaper;